import { IconMail, IconSettings, IconBrandHipchat } from '@tabler/icons-react';

const settings = {
    id: 'settings',
    title: 'SETTINGS',
    icon: IconSettings,
    type: 'group',
    children: [
        {
            id: 'settings-email-template',
            title: 'EMAIL TEMPLATES',
            type: 'item',
            url: '/email-templates',
            icon: IconMail,
            breadcrumbs: false,
            tags: ['setting', 'settings', 'email', 'template', 'template']
        },
        {
            id: 'settings-support',
            title: 'SUPPORT',
            icon: IconBrandHipchat,
            type: 'item',
            url: '/support',
            breadcrumbs: false,
            tags: [
                'support',
                'help',
                'support ticket',
                'ticket',
                'tickets',
                'issue',
                'issues',
                'problem',
                'bug',
                'report issue',
                'help request',
                'support request',
                'customer support',
                'client support'
            ],
            // this will hold all the pages or pages card that will show in the page
            dynamicPages: [
                {
                    title: 'Analyse Text',
                    id: '',
                    tags: [
                        'analyse text',
                        'analyze text',
                        'text analysis',
                        'text analyser',
                        'text analyzer',
                        'reading analysis',
                        'reading comprehension',
                        'comprehension analysis',
                        'text difficulty',
                        'readability',
                        'readability score',
                        'lln analysis',
                        'lln text analysis',
                        'lln reading',
                        'literacy analysis'
                    ],
                    urlParams: 'analyse-text'
                },
                {
                    title: 'Trigger Words Database',
                    tags: [
                        'trigger words',
                        'trigger word',
                        'trigger list',
                        'trigger words database',
                        'trigger words list',
                        'trigger terms',
                        'sensitive words',
                        'flagged words',
                        'flagged terms',
                        'word triggers',
                        'term triggers'
                    ],
                    urlParams: 'trigger-words'
                },
                {
                    title: 'Dash Users',
                    tags: [
                        'dash users',
                        'dashboard users',
                        'users',
                        'user accounts',
                        'account users',
                        'system users',
                        'platform users',
                        'admin users',
                        'admin accounts'
                    ],
                    urlParams: 'dash-users'
                },
                {
                    title: 'Deployment Groups',
                    tags: [
                        'deployment group',
                        'deployment groups',
                        'groups',
                        'client groups',
                        'organisation groups',
                        'organization groups',
                        'deployment categories',
                        'deployment collections'
                    ],
                    urlParams: 'deployment-groups'
                }
            ]
        }
    ]
};

export default settings;
